





































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import Swipe from '../../components/Swipe.vue'
import Tab from './components/Tab.vue'
import Card from './components/Card.vue'
import Tag from './components/TagSearch.vue'
import TabTheme from './components/TabTheme.vue'
import {Action, Mutation, State} from "vuex-class"
import {keepData} from "../../utils";
import Music from '../../components/Music.vue'

@Component({
  components: {
    Swipe,
    Tab,
    Card,
    Music,
    Tag,
    TabTheme
  }
})
export default class Index extends Vue {
  @State activeArticleList
  @State accountInfo
  @State sideBarSettings
  @State activeTab
  @State music
  @State requestOver
  @State isEnd
  @State slideList
  @State userConfig
  @State initReady
  @State templateId
  @State pageStatus
  @State tabs
  @State activeTabIndex
  @Action pageInit
  @Action getTabArticle
  @Action getSearchArticle
  @Mutation setActiveTab
  title: string = '' // 标题
  pageId: string | number = '' // 页面id
  showCode: boolean = false // 显示二维码
  wrapHeight: number | string = 'auto'

  activeThemeIndex = 0

  get tabTheme() {
    const tabs = this.tabs.filter(item => item.label)
    const labels = Array.from(new Set(this.tabs.map(item => item.label)))
    console.log('labels', labels)
    if (!labels.length) return []
    const obj: any = {}
    tabs.forEach((item, tabIndex) => {
      if (!obj[item.label]) {
        obj[item.label] = []
      }
      item.tabIndex = tabIndex
      obj[item.label].push(item)
    })
    console.log('obj', obj)
    return Object.keys(obj).map(key => {
      return {
        title: key.replace('：', ''),
        list: obj[key]
      }
    })
  }

  bodyHeight = '100px'

  get musicStatus() {
    return this.music.open && this.music.url && !this.$route.query.iframe
  }

  onThemeChange(val) {
    if (val === this.activeThemeIndex) return
    this.activeThemeIndex = val
    if (val === -1) {
      this.setActiveTab({})
      return
    }
    this.setActiveTab(this.tabTheme[val].list[0])
    this.getTabArticle()
  }

  @Watch('showCode')
  handleShowCodeChange(val) {
    console.log('change', val)
  }

  handleReachBottom() {
    if (!this.initReady) return 0
    if (!this.activeTab['id']) {
      return this.getSearchArticle()
    } else {
      return this.getTabArticle()
    }
  }

  async mounted() {
    let self = this
    self.wrapHeight = window.innerHeight
    const query: myInterface.Query = self.$route.query as myInterface.Query
    // 恢复数据
    const keep = await keepData()
    // 如果没有数据可以恢复，请求新数据
    if (!keep) {
      await self.pageInit({
        activeTabIndex: query['defaultInit'] ? Number(query['defaultInit']) : 1,
        pageId: query['pageId']
      })
    }

    this.activeThemeIndex = this.tabTheme.findIndex(item => item.title === this.tabs[this.activeTabIndex].label.replace('：', ''))

    this.$nextTick(() => {
      //ts-ignore
      this.bodyHeight = (document.documentElement.clientHeight - this.$refs.header['offsetHeight']) + 'px'
    })
  }

}
